import { useEffect, useState, useRef } from "react";

export function useElapsed(startIso) {
  const [sec, setSec] = useState(() => calc(startIso));
  useEffect(() => {
    setSec(calc(startIso));
    const id = setInterval(() => setSec(calc(startIso)), 1000);
    return () => clearInterval(id);
  }, [startIso]);
  return sec;
}

function calc(startIso) {
  if (!startIso) return 0;
  const start = new Date(startIso).getTime();
  return Math.max(0, Math.floor((Date.now() - start) / 1000));
}

// Returns "green" | "amber" | "red" | "darkred" | "grey"
export function colorState(seconds, sla) {
  if (!sla) return "grey";
  if (seconds >= sla.critical_minutes * 60) return "darkred";
  if (seconds >= sla.overdue_minutes * 60) return "red";
  if (seconds >= sla.warning_minutes * 60) return "amber";
  return "green";
}

export function fmtTimer(seconds) {
  if (seconds == null) return "--:--";
  const neg = seconds < 0;
  const s = Math.abs(seconds);
  const m = Math.floor(s / 60);
  const r = s % 60;
  const mm = String(m).padStart(2, "0");
  const rr = String(r).padStart(2, "0");
  return `${neg ? "-" : ""}${mm}:${rr}`;
}

export function fmtDuration(seconds) {
  if (seconds == null || seconds === "") return "—";
  const s = Math.abs(Math.round(seconds));
  const m = Math.floor(s / 60);
  const r = s % 60;
  if (m === 0) return `${r}s`;
  return `${m}m ${r}s`;
}

export function fmtTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString([], { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
}

export const STATE_COLORS = {
  green: "#22C55E",
  amber: "#F59E0B",
  red: "#FF3B30",
  darkred: "#FF3B30",
  grey: "#52525B",
};
